import React from "react";
import { useSelector } from "react-redux";
import QuestionList from "../QusetionList/QuestionList";
import classes from './QuestionListContainer.module.css'


const QuestionListContainer = ({ reflection, currentIndex, addReflection, setCurrentIndex, portalId }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.QuestionsContainer}>
            <div className={classes.Title}>{texts.questionnaireCourse}</div>
            <div id={portalId} />
            <QuestionList
                reflection={reflection}
                addReflection={addReflection}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
            />
        </div>
    )
}

export default QuestionListContainer;